import React, { useEffect, useState, ChangeEvent, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, InputBase, Box } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, debounce } from 'lodash';
import { round } from 'mathjs';

import '../../scss/public.scss';
import '../scss/index.scss';
import Color from '@tool/color';
import SubTitle from '../../component/sub-title';
import Tab from '../../component/tab';
import TimeTab from '../../component/time-tab';
import CommonTable from '../../component/common-table';
import Empty from '@/component/empty';
import moIndustryEffect, {
  changeType, supportTimeChange, changeValue,
} from './store/index';
import { DBox, DInput } from '../styled';
import {
  EntityHuman, CircleHuman, EntityCaiwu, CircleCaiwu,
  EntityFawu, CircleFawu, EntityIT, CircleIT,
  EntityXingzheng, CircleXingzheng,
} from '@styled/icon';
import moEffect from '../../store/index';
import moSupport from '../store';
import { exportExcelFile } from '@/tool';

interface IProps {}
interface IState {}

const IndustryEffect = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    type, empty, staffCount, timeActive,
    arr, tableTitle, tableList, maxStaff, overview,
  } = moIndustryEffect;
  const { yearList } = moEffect;

  const exporttable = () => {
    const list:any = [tableTitle, ...tableList];
    const merge:any = [];
    exportExcelFile(list, merge, '各行业支持效能');
  };

  useEffect(() => {
    return () => { };
  }, []);

  const colors = (index: number, opacity: number) => {
    const arr = [
      `rgba(52, 63, 153, ${opacity})`,
      `rgba(248, 171, 66, ${opacity})`,
      `rgba(134, 212, 224, ${opacity})`,
      `rgba(250, 100, 1, ${opacity})`,
      `rgba(157, 162, 176, ${opacity})`,
      `rgba(133, 218, 50, ${opacity})`,
      `rgba(73, 121, 215, ${opacity})`,
      `rgba(112, 32, 130, ${opacity})`,
      `rgba(182, 100, 210, ${opacity})`,
      `rgba(0, 195, 137, ${opacity})`,
      `rgba(255, 82, 82, ${opacity})`,
      `rgba(204, 204, 204, ${opacity})`,
    ];
    return arr[index];
  };

  const humans = (name: string, count: number, idx: number) => {
    const doms: any[] = [];
    const length = (count / maxStaff) * 20;
    for (let i = 1; i <= length; i += 1) {
      if (name.includes('人力资源')) {
        doms.push(<EntityHuman color={colors(idx, 1)} height={20} width={20} key={i} />);
      } else if (name.includes('财务')) {
        doms.push(<EntityCaiwu color={colors(idx, 1)} height={16} width={16} key={i} />);
      } else if (name.includes('IT')) {
        doms.push(<EntityIT color={colors(idx, 1)} height={16} width={16} key={i} />);
      } else if (name.includes('行政')) {
        doms.push(<EntityXingzheng color={colors(idx, 1)} height={16} width={16} key={i} />);
      } else if (name.includes('法务')) {
        doms.push(<EntityFawu color={colors(idx, 1)} height={16} width={16} key={i} />);
      }
    }
    return doms;
  };

  const locateValue = (value: any) => {
    if (isNaN(value)) return '-';
    if (value === null || value === '' || value === undefined) return '-';
    if (value <= 0) return '-';
    return Number(value).toLocaleString();
  };

  return (
    <section id="effect15" className="effect-10 box-111">
      <SubTitle title="各行业支持效能" subtitle="多行业比对" active={type}
        bg={Color.secondaryColor(0.1)} color={Color.secondary}
        tabChange={(val: string) => changeType(val)} />

      {type === 'chart' ? (
        <section className="content-151 content-152 content-153">
          {!empty ? (
            <section className="content-255">
              <section className="line-301"
                style={{ paddingLeft: '120px' }}>
                <span>全职员工数</span>
                <DBox>
                  <DInput value={staffCount}
                    onChange={(ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => changeValue(ev)}
                    placeholder="请输入" />
                  <b>人</b>
                </DBox>
              </section>
              <p className="line-302"
                style={{ paddingLeft: '120px' }}>
                请输入全职员工数，系统将依据调研到的支持效能的比值，换算成该人员规模下，建议的各支持部门的人员数量配置。
              </p>

              <section className="content-6699">
                <section className="content-66990">
                  {arr.map((item: any, index: number) => (
                    <section key={index} className="content-30">
                      <strong>{item.category}</strong>
                      <section className="content-31">
                        {item.data?.map((child: any, idx: number) => (
                          <section key={idx} className="content-33">
                            <section className="content-3301 content-3303">
                              {idx !== 0 ? <p className="place-3301" /> : null}
                              <p className="line-3301">
                                <span>{child.label}</span>
                                <span className="digit-11">
                                  &nbsp;{locateValue(child.count)}&nbsp;
                                </span>
                                {child.count > 0 ? (
                                  <span>人</span>
                                ) : (
                                  <span className="digit-11">-</span>
                                )}
                              </p>
                            </section>
                            <section className="content-3301 content-3305">
                              {idx !== 0 ? <p className="place-3301" /> : null}
                              <section className="line-3302">
                                <p className={[
                                  'icon-111',
                                  !item.category.includes('人力资源') ? 'icon-115' : '',
                                ].join(' ')}>
                                  {humans(item.category, child.count, idx)}
                                </p>
                                {!Number.isInteger(child.count / maxStaff * 20) ? (
                                  <p className="icon-111">
                                    {item.category.includes('人力资源') ? (
                                      <CircleHuman color={colors(idx, 1)} height={20} width={20} />
                                    ) : null}
                                    {item.category.includes('财务') ? (
                                      <CircleCaiwu color={colors(idx, 1)} height={16} width={16} />
                                    ) : null}
                                    {item.category.includes('法务') ? (
                                      <CircleFawu color={colors(idx, 1)} height={16} width={16} />
                                    ) : null}
                                    {item.category.includes('IT') ? (
                                      <CircleIT color={colors(idx, 1)} height={16} width={16} />
                                    ) : null}
                                    {item.category.includes('行政') ? (
                                      <CircleXingzheng color={colors(idx, 1)} height={16} width={16} />
                                    ) : null}
                                  </p>
                                ) : null}
                              </section>
                            </section>
                          </section>
                        ))}
                      </section>
                    </section>
                  ))}
                </section>
                <section className="chart-detail_11 industry-detail_11"
                  style={{ width: '410px', height: 'auto' }}>
                  {overview.map((item: any, index: number) => (
                    <section key={index} className="item">
                      <span className="circle-111"><b /></span>
                      <p className="line-111 line-1115">
                        {item.map((child: any, idx: number) => (
                          <Fragment key={idx}>
                            {child.mark === 'number' ? (
                              <span className="blue-11">{`${Number(child.value).toLocaleString()}`}</span>
                            ) : null}
                            {child.mark === 'change_ratio' ? (
                              <>
                                {child.value >= 0 ? (
                                  <span className="red-11">{`${Number(child.value).toLocaleString()}`}</span>
                                ) : (
                                  <span className="green-11">{`${Number(child.value).toLocaleString()}`}</span>
                                )}
                              </>
                            ) : null}
                            {(child.mark !== 'number' && child.mark !== 'change_ratio') ? (
                              <span className="span-11">{child.value}</span>
                            ) : null}
                          </Fragment>
                        ))}
                      </p>
                    </section>
                  ))}
                </section>
              </section>
            </section>
          ) : (<Empty />)}
        </section>
      ) : (
        <section className="content-151 content-152">
          {!empty ? (
            <section className="content-255"
              style={{ marginTop: '20px' }}>
              <section className="line-301"
                style={{ paddingLeft: '120px' }}>
                <span>全职员工数</span>
                <DBox>
                  <DInput value={staffCount}
                    onChange={(ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => changeValue(ev)}
                    placeholder="请输入" />
                  <b>人</b>
                </DBox>
              </section>
              <p className="line-302"
                style={{ paddingLeft: '120px' }}>
                请输入全职员工数，系统将依据调研到的支持效能的比值，换算成该人员规模下，建议的各支持部门的人员数量配置。
              </p>
              {type === 'table' && <section onClick={exporttable} className='export-table'>导出excel</section>}
              <CommonTable titleList={tableTitle} list={tableList} />
            </section>
          ) : (<Empty />)}
        </section>
      )}
      <TimeTab list={yearList} active={timeActive} onChange={supportTimeChange} />
    </section>
  );
};

export default observer(IndustryEffect);
